export default [
  {
    path: '/map/index',
    name: 'Index',
    component: () => import('@/views/map/index'),
    meta: {
      title: '地图-高考直通车'
    }
  },
  
]
